import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import { withRouter } from 'react-router-dom';
import icon_self_test_record from '../../static/images_ae/personal/icon_self_test_record.png';
import icon_points_get_record from '../../static/images_ae/personal/icon_points_get_record.png';
import icon_personal_files from '../../static/images_ae/personal/icon_personal_files.png';
import icon_agreement_privacy from '../../static/images_ae/personal/icon_agreement_privacy.png';
import icon_suggestion_feedback from '../../static/images_ae/personal/icon_suggestion_feedback.png';
import icon_alk_risk from '../../static/images_ae/personal/icon_alk_risk.png';
import icon_alk_more from '../../static/images_ae/personal/icon_alk_more.png';
import avatar from '../../static/images_ae/personal/avatar.png';
import point_icon from '../../static/images_ae/pointsMall/point_icon.png';
import styles from './index.module.scss';

const api = new ApiCore();

const AePersonal = (props: any) => {

    const [personalInfo, setPersonalInfo] = useState<any>({})
    const [age, setAge] = useState<any>(null);
    const [pointCount, setPointCount] = useState<any>(null);

    useEffect(() => {
        window.document.title = '个人中心';
    }, [])


    useEffect(() => {
        // initPoint();
        // initPersonal();
    }, [])

    useEffect(() => {
        // 每次切换tab更新最新数据，积分等
        if (props.selectedTab && props.selectedTab.indexOf('personal') >= 0) {
            initPoint();
            initPersonal();
        }
    }, [props.selectedTab])

    const initPoint = () => {
        api.toGetAeAllCount().then((res: any) => {
            if (res.code == 0) {
                setPointCount(res.data);
            }
        })
    }

    const initPersonal = () => {
        api.getAePersonalInfo().then((res: any) => {
            if (res.code == 0) {
                let _data = res.data || {};
                setPersonalInfo(_data);
                if (Object.keys(_data).length > 0) {
                    _data.birthTime && calcAge(_data.birthTime);
                }
            }
        })
    }

    const calcAge = (birthTime: any) => {
        const _age = (new Date().getFullYear()) - parseInt(birthTime.slice(0, 4));
        setAge(_age);
    }

    const toPointRecord = () => {
        props.history.push('/ae/pointsRecords');
    }

    const toTestRecord = () => {
        props.history.push('/alk/testReord');
    }

    const toRecord = () => {
        props.history.push('/ae/reporting/record');
    }

    const toCommonAsk = () => {
        props.history.push('/alk/commonAsk');
    }

    const toPricacy = () => {
        props.history.push('/alk/privacy');
    }

    return (
        <div className={styles.ae_personal_content}>
            <div className={styles.head}>
                <div className={styles.defaultavatar}><img src={avatar} alt="" /></div>
                <div className={styles.head_card}>
                    <div className={styles.head_card_name}>
                        微信用户
                    </div>
                    {/* <div className={styles.head_card_info}>
                        <span>{personalInfo.sex == 1 ? '男' : personalInfo.sex == 0 ? '女' : ''}</span>
                        {
                            age >=0 &&
                            <span>{age}岁</span>
                        }
                    </div> */}
                    <div className={styles.head_card_bottom}>
                        <img src={point_icon} alt="" />
                        <div className={styles.head_card_bottom_txt}>可用积分：{pointCount}</div>
                    </div>
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.risk_record} onClick={() => { toRecord() }}>
                    <img className={styles.icon_risk} src={icon_alk_risk} alt="" />
                    <div className={styles.risk_text}>ALK风险评估记录</div>
                    <img className={styles.icon_more} src={icon_alk_more} alt="" />
                </div>
                <div className={styles.info_item} onClick={() => { toTestRecord() }}>
                    <img className={styles.icon_item} src={icon_self_test_record} alt="" />
                    <div className={styles.item_content}>量表自测记录</div>
                </div>
                <div className={styles.info_item} onClick={() => { toPointRecord() }}>
                    <img className={styles.icon_item} src={icon_points_get_record} alt="" />
                    <div className={styles.item_content}>积分获取记录</div>
                </div>
                {/* <div className={styles.info_item}>
                    <img className={styles.icon_item} src={icon_personal_files} alt="" />
                    <div className={styles.item_content}>个人档案</div>
                </div> */}
                <div className={styles.info_item} onClick={() => { toPricacy() }} >
                    <img className={styles.icon_item} src={icon_agreement_privacy} alt=""/>
                    <div className={styles.item_content}>{'用户协议&隐私政策'}</div>
                </div>
                {/* <div className={styles.info_item}>
                    <img className={styles.icon_item} src={icon_suggestion_feedback} alt="" />
                    <div className={styles.item_content}>意见反馈</div>
                </div> */}
                {/* <div className={styles.info_item} onClick={() => { toCommonAsk() }}>
                    <img  className={styles.icon_item} src={icon_self_test_record} alt="" />
                    <div className={styles.item_content}>常见问答</div>
                </div> */}
            </div>
        </div>
    )
}

export default withRouter(AePersonal);